// extracted by mini-css-extract-plugin
export default {"root":"switch_root__GrnD8","thumb":"switch_thumb__FMaCK","track":"switch_track__NPaPB","input":"switch_input__tCh2O","body":"switch_body__nvMG3"};